import React, { useCallback, useMemo, useContext } from 'react'
import useGroomingVisit from '../../../../../hooks/useGroomingVisit'
import OptionsMenu from '../../../../Common/OptionsMenu/OptionsMenu'
import SectionFormContainer from '../../../components/SectionFormContainer'
import GroomingAppointmentWizardContext from '../GroomingAppointmentWizardContext'

const BODY_STYLE_OPTIONS = [
	{
		label: 'Keep Coat Length',
		description: 'Do a full outline trim on my pup to neaten them up all over.',
		value: 'Outline'
	},
	{
		label: 'Shave Down All Over',
		description: `My pup's fur should be under 0.5 inches all over.`,
		value: 'Shave'
	},
	{
		label: 'Clip - 0.5" to 1" Long',
		description: `My pup's fur should be between 0.5 inches and 1 inches all over.`,
		value: 'Short Clip'
	},
	{
		label: 'Clip - 1" to 1.5" Long',
		description: `My pup's fur should be between 1 inch and 1.5 inches all over.`,
		value: 'Medium Clip'
	},
	{
		label: 'Clip - Longer than 1.5"',
		description: `My pup's fur should be longer than 1.5 inches all over.`,
		value: 'Long Clip'
	},
	{
		label: 'Something Else (Specific Cut)',
		description: `Breed specific cut or other style. Please explain in the comments.`,
		value: 'Other'
	}
]

const BodyStyle = (props) => {
	const {
		wizardContextProvider: { grooming_appointment, setWizardAttributeAndValues }
	} = useContext(GroomingAppointmentWizardContext)
	const { visit_attr, subtext = '', title = '' } = props
	const { loading, facility } = useGroomingVisit()

	const handleSelection = useCallback(
		(type) => {
			const newValues = { ...grooming_appointment }
			newValues[visit_attr] = type
			setWizardAttributeAndValues(newValues)
		},
		[grooming_appointment, setWizardAttributeAndValues, visit_attr]
	)

	const options = useMemo(() => {
		const opts = BODY_STYLE_OPTIONS.map(({ label, description, value }, i) => {
			const option = {
				title: label,
				description,
				id: i,
				disabled: loading || grooming_appointment[visit_attr] === value,
				selected: grooming_appointment[visit_attr] === value,
				onSelected: () => handleSelection(value)
			}
			return option
		})

		return opts
	}, [facility, handleSelection, loading, grooming_appointment, visit_attr])

	return (
		<SectionFormContainer title={title} subtext={subtext}>
			<OptionsMenu options={options} />
		</SectionFormContainer>
	)
}

export default BodyStyle
